/* eslint-disable @typescript-eslint/no-var-requires */
import color from './tokens/color';
import font from './tokens/font';
import radius from './tokens/radius';
import spacing from './tokens/spacing';
import shadow from './tokens/shadow';
import variant from './tokens/variant';
import globals from './tokens/globals';
import palette from './tokens/palette';

// we need a name 'theme' to not break theme-merge-plugin
const theme = {
  radius,
  font,
  spacing,
  palette,
  shadow,
  globals,
  // need to deprecate
  variant,
  color,
};
export default theme;
